module.exports = __webpack_public_path__ + "static/img/1-4.9fcd41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/aboutUs/1-4.png
// module id = Iqed
// module chunks = 1